/**
 * AI 解析の 1 日上限 (docs/13 §9-3、AC-13.9) の既定値・上限値と、地区設定の解決・入力検証 (pure)。
 *
 * functions (`functions/src/common/aiQuota.ts` が実際に数えて止める) と admin (地区の AI 設定画面で
 * master が変更する) が同じ値を使うためここに置く (二重定義をしない)。
 *
 * 地区 doc の `aiAnalysis.dailyQuota.{perDistrict, perUser}` で地区ごとに変えられる
 * (`aiAnalysis` は firestore.rules で master だけが書ける)。未設定・不正値は既定値、
 * 上限を超える値は上限で丸める (誤設定で青天井にしない)。
 */
/** 参加者 1 人あたりの 1 日上限 (既定)。 */
export const AI_DAILY_QUOTA_PER_USER = 150;
/** 地区あたりの 1 日上限 (既定)。 */
export const AI_DAILY_QUOTA_PER_DISTRICT = 3000;
/** 地区の上書き値の上限 (参加者 1 人あたり)。 */
export const AI_DAILY_QUOTA_PER_USER_MAX = 2000;
/** 地区の上書き値の上限 (地区あたり)。 */
export const AI_DAILY_QUOTA_PER_DISTRICT_MAX = 100_000;
function clampLimit(v, fallback, max) {
    if (typeof v !== 'number' || !Number.isFinite(v) || v < 1)
        return fallback;
    return Math.min(Math.floor(v), max);
}
/** 地区 doc (Firestore 由来なので unknown) から実効の 1 日上限を解決する。 */
export function resolveAiDailyQuotaLimits(district) {
    const q = district?.aiAnalysis
        ?.dailyQuota;
    return {
        perUser: clampLimit(q?.perUser, AI_DAILY_QUOTA_PER_USER, AI_DAILY_QUOTA_PER_USER_MAX),
        perDistrict: clampLimit(q?.perDistrict, AI_DAILY_QUOTA_PER_DISTRICT, AI_DAILY_QUOTA_PER_DISTRICT_MAX),
    };
}
function parseOne(raw, label, max) {
    const s = raw.trim().replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0));
    if (s === '')
        return { value: null };
    if (!/^\d+$/.test(s)) {
        return { value: null, error: `${label}は整数で入力してください。` };
    }
    const n = Number(s);
    if (n < 1 || n > max) {
        return {
            value: null,
            error: `${label}は 1〜${max.toLocaleString('ja-JP')} の範囲で入力してください。`,
        };
    }
    return { value: n };
}
/**
 * 管理画面の入力欄 (文字列) を検証する。空欄 = 既定値を使う。範囲外・整数以外はエラー。
 */
export function parseAiDailyQuotaInput(input) {
    const d = parseOne(input.perDistrict, '地区あたりの上限', AI_DAILY_QUOTA_PER_DISTRICT_MAX);
    const u = parseOne(input.perUser, '参加者 1 人あたりの上限', AI_DAILY_QUOTA_PER_USER_MAX);
    if (d.error || u.error) {
        const errors = {};
        if (d.error)
            errors.perDistrict = d.error;
        if (u.error)
            errors.perUser = u.error;
        return { ok: false, errors };
    }
    return { ok: true, perDistrict: d.value, perUser: u.value };
}
//# sourceMappingURL=aiDailyQuota.js.map